import React from 'react'
import {IProject, ITask, ITimesheet} from "../../../models";
import {MonthNumber} from "../../../constants/MonthNumber";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import logo from './../../../assets/html/img/logo-2.png'
import imageToBase64 from 'image-to-base64/browser';
import {Timesheet} from "../../../components/excel/Timesheet";

interface ITimesheetExcelProps {
    chosenTimesheet: ITimesheet
    tasks: ITask[]
    translate: any
    chosenProject?: IProject
}

export const TimesheetExcel = async ({chosenTimesheet, tasks, translate, chosenProject}: ITimesheetExcelProps) => {
    try {
        const today = `${String(new Date().getFullYear()).slice(2, 4)}${(new Date().getMonth() + 1) < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1}${new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate()}`
        
        // Parse month from date format DD/MM/YY
        const month = chosenTimesheet?.date?.split('/')[1] ?? (chosenTimesheet?.date?.[3] + chosenTimesheet?.date?.[4])
        const monthNum = Number(month)
        const monthTitle = MonthNumber()[monthNum]?.en_title ?? 'Unknown'
        
        const documentName = `${today}_Timesheet_${chosenTimesheet?.user?.first_name}_${chosenTimesheet?.user?.last_name}_${monthTitle}`

        const workbook = new ExcelJS.Workbook();
        const worksheetTimesheet = workbook.addWorksheet(documentName);

        const base64Logo = await imageToBase64(logo) // Path to the image

        const imageId = workbook.addImage({
            base64: base64Logo,
            extension: 'png',
        });

        Timesheet({worksheet: worksheetTimesheet, chosenTimesheet, tasks, translate, logo: imageId, chosenProject, month})

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {type: 'application/octet-stream'});
        FileSaver.saveAs(blob, `${documentName}.xlsx`);
    } catch (error) {
        console.error('Error exporting timesheet to Excel:', error);
        alert('Error exporting to Excel. Please check console for details.');
    }
}
